import { Injectable } from '@angular/core';
import { Incident } from '../models/Incident';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Affranchi } from '../models/Affranchi';
import { StatutIncident } from '../models/StatuIncident';

@Injectable({
  providedIn: 'root',
})
export class IncidentService {
  constructor(private http: HttpClient) {}

  public getListFormated(listIncident: Incident[]): Incident[] {
    listIncident.forEach((incident) => {});
    return listIncident;
  }

  public updateIncident(incident: Incident){
    return this.http.put<Incident>(`${environment.urlBackend}incident`, incident);
  }

  public createAffranchi(incident: Incident){
    return this.http.post<Affranchi>(`${environment.urlBackend}incident/affranchi`, incident);
  }


  public createAffranchiFromDashboard(incident: Incident, idDataComparison: number | undefined){
    return this.http.post<Affranchi>(`${environment.urlBackend}incident/affranchi/dashboard/${idDataComparison}`, incident);
  }

  public deleteAffranchi(idAffranchi: number){
    return this.http.delete(`${environment.urlBackend}incident/affranchi?idAffranchi=${idAffranchi}`);
  }
}
